export default __webpack_public_path__ + "static/media/office9full.ff7227ac.jpg";